import produce from 'immer';
import { useEffect, useState } from 'react';

import { API } from '../../../../../request/api';

const useFilter = () => {
  const [type, set_type] = useState(1);
  const [price_from, set_price_from] = useState('');
  const [price_to, set_price_to] = useState('');
  const [date_from, set_date_from] = useState(null);
  const [date_to, set_date_to] = useState(null);
  const [next, set_next] = useState(1);
  const [filtered_list, set_filtered_list] = useState([]);
  const [sort_visible, set_sort_visible] = useState(false);
  const [sort_value, set_sort_value] = useState(1);
  const [loading, set_loading] = useState(true);

  const filterDate = async (from_infinite = false) => {
    set_loading(true);
    await API.get
      .credits(type, price_from, price_to, date_from, date_to, sort_value, from_infinite ? next : 1)
      .then((response) => {
        set_loading(false);
        if (response.code === 200) {
          if (response.pagination.page !== 1) {
            set_filtered_list(
              produce((draft) => {
                (response?.data || []).forEach((item) => {
                  if (!draft.find((find_item) => find_item.id === item.id)) {
                    draft.push(item);
                  }
                });
              })
            );
            set_next(response.pagination.next);
          } else {
            set_filtered_list(response.data);
            set_next(response.pagination.next);
          }
        }
        return response;
      });
  };

  const submit_filter = (from_infinite = false) => {
    filterDate(from_infinite);
  };

  useEffect(() => {
    filterDate();
  }, [sort_value]); // eslint-disable-line

  return [
    type,
    set_type,
    price_from,
    set_price_from,
    price_to,
    set_price_to,
    date_from,
    set_date_from,
    date_to,
    set_date_to,
    sort_visible,
    set_sort_visible,
    sort_value,
    set_sort_value,
    filtered_list,
    submit_filter,
    next,
    filterDate,
    loading
  ];
};

export default useFilter;
